import { Text } from '@cdl/heartbeat-react';
import { AppThunk } from '../../../store/rootReducer';
import { LONG_NOTIFICATION_DURATION } from '../../../shared/notification/utils/constants.utils';
import { MILLISECOND, secondsToMs } from '../../utils/time';
import * as ecgActions from '../actions/ecg.actions';
import * as signalActions from '../actions/signal.actions';
import * as ecgClient from '../clients/ecg.client';
import { exactDurationSelector } from '../selectors/ecg.selectors';
import { Leads } from '../types/signal';
import { displayNotification } from '../../../shared/notification/display-notification';

export const loadSignal =
  (ecgId: string): AppThunk =>
  async (dispatch, getState) => {
    const signal = await ecgClient.getSignal(ecgId);

    if (signal == null) {
      throw new Error('signal is missing');
    }

    dispatch(
      signalActions.loaded({
        signal,
        meta: { history: false },
      }),
    );

    const ecgDuration = exactDurationSelector(getState());
    const signalDuration = computeSignalDuration(
      signal.leads,
      signal.frequency,
    );

    if (Math.abs(ecgDuration - signalDuration) < MILLISECOND) {
      return;
    }

    dispatch(
      ecgActions.update({
        update: { duration: signalDuration },
        meta: { history: false },
      }),
    );

    displayNotification({
      title: 'Warning',
      description: (
        <>
          <Text>
            The ecg's duration doesn't match the one computed from the signal.
          </Text>
          <Text>Using the signal's duration instead.</Text>
        </>
      ),
      status: 'warning',
      duration: LONG_NOTIFICATION_DURATION,
    });
  };

const computeSignalDuration = (leads: Leads = {}, frequency = 0) => {
  const firstLead = Object.keys(leads)[0];
  if (firstLead == null || frequency === 0) {
    return 0;
  }
  return secondsToMs(leads[firstLead].length / frequency, false);
};
